import DateInfo from './DateInfo';

export default DateInfo;
